module.exports = __webpack_public_path__ + "static/Maddie0-5e32ef585970d8bc941321aee39ffaf3.jpg";